// extracted by mini-css-extract-plugin
module.exports = {"container":"xFoGI_","mobile":"_3t9_pb"};